/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type { ListHomepagePinsQueryResponse } from '../types/ListHomepagePins'

function getListHomepagePinsUrl() {
  const res = { method: 'GET', url: `/api/v1/homepage/pins/` as const }
  return res
}

/**
 * @summary List the current user's homepage pins
 * {@link /api/v1/homepage/pins/}
 */
export async function listHomepagePins(
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    ListHomepagePinsQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: 'GET',
    url: getListHomepagePinsUrl().url.toString(),
    ...requestConfig,
  })
  return res.data
}
